// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__23ZT9","label":"Radio_label__1CX5u","checkMark":"Radio_checkMark__3Uz3P","disabled":"Radio_disabled__1BrJz"};